export default "__VITE_ASSET__4fb6dafb__"